// ! NOTE: Add new variables as needed

const variables = {
  isPrimary: true,
};

export default variables;
